module.exports = __webpack_public_path__ + "img/ios-download.971882aa.png";